import { render, staticRenderFns } from "./InvestorOnboardingPhone.vue?vue&type=template&id=9974cc5e&"
import script from "./InvestorOnboardingPhone.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports